<template>
  <div class="instance-purchase-new-thank-you">
    <nuttrema-empty-result
       class="with-logo"
       predefined-set="thank-you">
    </nuttrema-empty-result>
  </div>
</template>

<script>
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

export default {
  name: 'page-instance-purchase-new-thank-you',
  components: {
    NuttremaEmptyResult,
  },
  created() {
    this.$store.dispatch('GetInstanceSubscriptionsList');
  },
};
</script>

<style lang="scss" scoped>
  .instance-purchase-new-thank-you {

  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/subscriptions/purchase-new/step-3/page-instance-purchase-new-thank-you.vue